import { LitElement, html, css, unsafeCSS } from "lit";
import { ref, createRef } from "lit/directives/ref.js";
import { slDialog } from "@shoelace-style/shoelace/dist/components/dialog/dialog.js";
import { customElement } from "lit/decorators.js";
//import bankingVideo from "../../assets/banking-example.mp4";
import { OverlayScrollbars } from "overlayscrollbars";
import "overlayscrollbars/overlayscrollbars.css";
import ZipCodeVerify from "../../assets/js/lib/zipcode-verify";

//import { createBrowserHistory } from "history";
class PanelController extends LitElement {
	static properties = {
		hideNav: { type: Boolean },
		animationDuration: { type: Number, attribute: "animation-duration", reflect: true },
		// selected: {
		// 	state: true,
		// },
	};

	static shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };

	constructor() {
		super();
		this.mainPanel = null;
		this.panels = [];
		this.selected = null;
		this.timestamp = Date.now();

		// Expect that we are usually starting at root
		this.currentPagePath = window.location.pathname;
		this.navController = null;

		this.hideNav = true;
		this.isAnimating = false;
		//this.historyController = null;
		this.scrollbar = null;

		this.animationDuration = 3000;
		this.transientDuration = 1000;
		//this.historyState = { id: "10101" };
		this.isRendered = false;

		this.lobbyNextBtn = null;
		this.lobbyPrevBtn = null;
	}

	static styles = css`
		:host {
			position: relative;
			display: flex;
			flex-flow: column nowrap;
			height: 100vh;
			background: var(--color-background);
		}

		.loader-panel-wrap {
			position: absolute;
			display: flex;
			top: 0;
			left: 0;
			height: 100%;
			width: 100%;
			z-index: 5000;
			transition: opacity 1s ease;
		}
		.loader-panel-wrap.hide {
			opacity: 0;
			pointer-events: none;
		}

		.display-panel {
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			width: 100%;
			z-index: 1;
			background: var(--color-background);
		}

		::slotted(.panel-list) {
			opacity: 0;
			//background-color: var(--color-background);
		}

		::slotted(.panel-list.active) {
			opacity: 1;
		}

		.hide {
			display: none;
			color: blue;
		}
	`;

	/**
	 * This is where the issue is occuring atm
	 * // TODO: Fix compositing issue
	 */
	connectedCallback() {
		super.connectedCallback();
		//console.log(this);

		this.heroScene = document.querySelector(".scrollbar-wrap");

		document.addEventListener("DOMContentLoaded", () => {
			this.scrollbar = OverlayScrollbars(this.heroScene, {
				autoUpdate: true,
				overflow: {
					y: "hidden",
					x: "scroll",
				},
				scrollbars: {
					autoHide: "leave",
					//	clickScrolling: true,
					snapHandle: true,
				},
			});
		});
		// Check zip code cookie

		//const zip = new ZipCodeVerify();
		//let zipCookie = zip.readCookie("fvb-zipcode");
		const modalCookie = document.cookie.includes("sorryModalViewed");
		if (modalCookie) {
			document.getElementById("modal-toggle").removeAttribute("checked");
		} else {
			document.getElementById("modal-toggle").setAttribute("checked", true);
		}

		this.navController = document.querySelector("nav-controller");

		// after 1 second add hide class to the loader-panel-wrap
		// also check cookie again. Setting interval to keep checking.

		let intervalId;
		const stopIntv = () => {
			clearInterval(intervalId);
		};

		const modalBtn = document.querySelector("[data-close-sorry-modal]");
		modalBtn.addEventListener("click", () => {
			document.cookie = "sorryModalViewed";
		});
		setTimeout(() => {
			intervalId = setInterval(() => {
				if (document.cookie.includes("sorryModalViewed")) {
					document.getElementById("modal-toggle").removeAttribute("checked");
					this.shadowRoot.querySelector(".loader-panel-wrap").classList.add("hide");
					runHandlerLater();
					// If this is the homepage with no hash display the intro panel
					if (window.location.pathname === "/" && window.location.hash === "") {
						//this.videoIntroHandler();
						this.hideNav = true;
					}

					console.log("not getting here");
					stopIntv();
				}
				console.log("We do get here though");
			}, 1000);
		}, 1000);

		const runHandlerLater = () => {
			setTimeout(() => {
				const panelSlot = this.shadowRoot.querySelector("slot[name=panel-list]").assignedNodes();
				// Toggle the display attribute from the panel list from display none to display contents
				//panelSlot.styles = "display: contents";
				//panelSlot.styles = "display: none";
				this.mainPanelHandler();
			}, 0);
		};
		// Select the main panel
		this.mainPanel = this.querySelector("[slot=main-panel]");

		document.querySelectorAll("a").forEach((link) => {
			link.addEventListener("click", (event) => {
				//event.preventDefault();
				//console.log(event.target.href.hash);
				// if (event.target.href) {
				// 	this.historyController.push(event.target.href);
				// 	this.navController.setActiveNavItem();
				// 	//this.urlHandler(event.target.href);
				// }
				const url = new URL(event.target.href);

				const path = new URL(event.target.href);
				const hash = new URL(event.target.href);

				// If the link is from the same site
				if (url.href.includes(window.location.origin) && url.pathname === "/") {
					event.preventDefault();

					console.log(path.pathname);
					console.log(hash.hash);
					if (url.hash === "") {
						const panelSlot = this.shadowRoot.querySelector("slot[name=panel-list]").assignedNodes();
						panelSlot[0].removeAttribute("data-active");
						window.history.pushState(null, "", "/");
						this.closePanel(this.selected);
						this.navController.setActiveNavItem();
					} else {
						// push this href to the window history
						window.history.pushState(null, "", event.target.href);
						this.newUrlHandler();
					}
				}

				//this.historyController.push(event.target.href);
			});
		});

		// this.historyController = createBrowserHistory();
		// this.historyController.listen((location, action) => {
		// 	console.log(location);
		// 	this.urlHandler();
		// 	this.currentPagePath = location.pathname;
		// 	//this.navigate(location.pathname);
		// });
		// Setup the history listener, this is the only way of easily listening for url changes without event listeners...
		// (function (history) {
		// 	const pushState = history.pushState;
		// 	history.pushState = function (state) {
		// 		console.log("I am called from pushStateHook");
		// 		console.log(this.isRendered);
		// 		if (this.isRendered) {
		// 			this.urlHandler();
		// 		}
		//
		// 		return pushState.apply(history, arguments) && this.urlHandler();
		// 	}.bind(this);
		// }.bind(this)(window.history));

		setTimeout(
			function () {
				this.isRendered = true;
				const panelSlot = this.shadowRoot.querySelector("slot[name=panel-list]").assignedNodes();
				this.panels = panelSlot[0].querySelectorAll("custom-panel");
				this.panelURLMap = new Map();
				//const panelsArray = Array.prototype.slice.call(this.panels.);
				//console.log(this.panels.assignedNodes());

				let index = 0;
				this.panels.forEach((panel) => {
					this.panelURLMap.set(panel.getAttribute("href"), panel);
					// set attribute for this panel
					panel.setAttribute("data-index", index);
					index++;
				});

				const query = new URLSearchParams(window.location.search);
				if (query.get("panel")) {
					window.history.pushState(null, "", `/#${query.get("panel")}`);
				}
				//this.update();
				//this.urlHandler();
				this.newUrlHandler();
			}.bind(this),
			1000
		);
	}

	newUrlHandler(url) {
		// if (!url) {
		// 	url = window.location.href;
		// }

		// Get pathname from url string
		//const path = new URL(url).pathname;
		//const hash = new URL(url).hash;

		// check to see if there is a query string
		//const query = new URL(url).searchParams;
		//console.log(query);
		//console.log(window.location.searchParams);
		const panelSlot = this.shadowRoot.querySelector("slot[name=panel-list]").assignedNodes();
		// If the link is a hash link on this page

		this.navController.setActiveNavItem();
		console.log(`Current URL: ${window.location.href}`);
		if (window.location.href.includes("#") && window.location.pathname == "/") {
			const hash = window.location.href.split("#")[1];
			// check if hash is in panel map

			const panel = this.panelURLMap.get(`/${hash.split("#")[0]}/`);
			if (panel) {
				panelSlot[0].setAttribute("data-active", "true");
				this.selectNewPanel(panel);
			} else {
				if (this.selected) {
					this.closePanel(this.selected);
				}
				panelSlot.setAttribute("data-active", "false");
			}
		}
	}

	//this.historyController.push(event.target.href);

	/**
	 * Selects a new active panel
	 *
	 * @param panelElement {Panel} The panel to select
	 */
	selectNewPanel(panelElement) {
		//console.log(panelElement);
		if (panelElement.getAttribute("id") === "intro") {
			this.openPanel(panelElement);
			this.selected = panelElement;
			this.navController.setActiveNavItem();
		} else {
			if (this.selected && this.selected !== panelElement) {
				this.closePanel(this.selected);
				//this.selected = panelElement;
				//this.openPanel(panelElement);
			}

			// get panel index
			const panelIndex = panelElement.getAttribute("data-index");
			// For any panel before this index set the attribute before
			this.panels.forEach((panel) => {
				const index = panel.getAttribute("data-index");
				if (index !== panelIndex) {
					if (index < panelIndex) {
						panel.setAttribute("before", "");
						panel.removeAttribute("after");
					} else {
						panel.removeAttribute("before");
						panel.setAttribute("after", "");
					}
				}
			});

			this.selected = panelElement;
			panelElement.openPanel();
		}
	}

	// Open a panel to render
	openPanel(panel) {
		panel.active = true;
		//panel.style.animationPlayState = "running";
		// Move the panel from the panel list into the active-panel slot
	}

	closePanel(panel) {
		panel.active = false;

		const video = panel.querySelector("video");
		if (video) {
			video.pause();
		}
	}

	returnToMainPanel(panel) {
		this.selected.closePanel();

		//this.selected = this.mainPanel;
	}

	mainPanelHandler() {
		this.topics = this.mainPanel.querySelectorAll(".topic");
		this.lobbyNextBtn = this.mainPanel.querySelector(".lobby-nav-button-right");
		this.lobbyPrevBtn = this.mainPanel.querySelector(".lobby-nav-button-left");
		let stagger = 0;
		this.topics.forEach((topic) => {
			topic.setAttribute("after", "");
			const lottiePlayer = topic.querySelector("dotlottie-player");
			setTimeout(() => {
				//lottiePlayer.seek(0);
				lottiePlayer.play();
			}, stagger);
			stagger += 200;
			// On mouse enter setup a mouse enter event listener
			// topic.addEventListener("mouseenter", (event) => {
			// 	// Select the lottie-player element and play it
			// 	//			const lottiePlayer = topic.querySelector("lottie-player");
			// 	lottiePlayer.seek("33%");
			// 	lottiePlayer.play();
			// });
		});

		setTimeout(() => {
			this.loopLotties();
		}, 4000);
		//this.scrollbar.scroll({ x: `+= ${scrollSpeed}px` });

		// this.heroScene.querySelector("#banking-on-the-go-main-graphic").scrollIntoView({
		// 	behavior: "smooth",
		// });
		this.scrollHandler(this.heroScene);
	}

	loopLotties() {
		this.topics.forEach((topic) => {
			const lottiePlayer = topic.querySelector("dotlottie-player");
			lottiePlayer.seek("37%");
			lottiePlayer.play();

			lottiePlayer.addEventListener("complete", (event) => {
				lottiePlayer.seek("37%");
				lottiePlayer.play();
			});
		});
	}

	videoIntroHandler() {
		// set a cookie that the video has been watched
		//document.cookie = "videoWatched=true";

		console.log(document.cookie);
		// if videoWatched cookie = false then play video
		if (!document.cookie.includes("videoWatched=true")) {
			console.log("yep we get inside");
			window.history.pushState({}, "", "#intro");
			//this.selectNewPanel();
			const panel = this.panelURLMap.get("/intro/");
			document.querySelector(".panel-list").setAttribute("data-active", "true");
			this.openPanel(panel);
			this.selected = panel;

			panel.querySelector("video").addEventListener("ended", (event) => {
				console.log("video ended");
				window.history.pushState({}, "", "/");
				this.closePanel(this.selected);
				const panelSlot = this.shadowRoot.querySelector("slot[name=panel-list]").assignedNodes();

				panelSlot[0].setAttribute("data-active", "false");
			});

			document.cookie = "videoWatched=true";
		}

		// Listen for the end of the video event and then pushstate back to /
	}

	// /**
	//  * Main controller of the app that handles the url changes and initial app state.
	//  * // TODO: This is where the issue occurs, when a panel should be rendered
	//  * @param url
	//  */
	// urlHandler(url) {
	// 	// Check to see if this anchor is on the same domain
	// 	if (url == null) {
	// 		url = window.location;
	// 	}
	// 	if (url.hostname === window.location.hostname) {
	// 		const panelSlot = this.shadowRoot.querySelector("slot[name=panel-list]").assignedNodes();
	//
	// 		if (window.location.pathname === "/") {
	// 			if (window.location.hash) {
	// 				console.log("found hash");
	// 				console.log(window.location.hash);
	// 				console.log(`/${window.location.hash.split("#")[1]}/`); //const navigation = this.querySelector("slot[name=navigation]");
	// 				this.hideNav = false;
	// 				const panel = this.panelURLMap.get(`/${window.location.hash.split("#")[1]}/`);
	// 				this.selectNewPanel(panel);
	// 				panelSlot[0].setAttribute("data-active", "true");
	// 				console.log(panelSlot[0]);
	// 			} else {
	// 				this.hideNav = true;
	// 				panelSlot[0].removeAttribute("data-active");
	//
	// 				if (this.selected) {
	// 					this.selected.closePanel();
	// 				}
	// 			}
	// 		} else if (this.panelURLMap.has(window.location.pathname)) {
	// 			if (this.selected.href !== url.pathname) {
	// 				const panel = this.panelURLMap.get(url.pathname);
	// 				console.log("we get inside the handler");
	// 				window.location = url.href;
	// 				this.selectNewPanel(panel);
	// 			} else if (this.panelURLMap.has(`/${window.location.hash.split("#")[1]}/`)) {
	// 				const panel = this.panelURLMap.get(`/${window.location.hash.split("#")[1]}/`);
	// 				this.selectNewPanel(panel);
	// 			}
	// 		} else {
	// 			console.log(window.location.pathname);
	// 			console.log("We don't have this panel");
	// 			window.location = window.location;
	// 			//window.history.pushState(this.historyState, "Fidelity-Virtual-Branch 404", "/404/");
	// 		}
	// 	} else {
	// 		// Outside link send them elsewhere
	// 		//window.location = url.href;
	// 		console.log("I would have reloaded");
	// 	}
	// }

	scrollHandler() {
		let topicIndex = 0;
		const currentTopic = this.topics[topicIndex];
		this.lobbyNextBtn.addEventListener("click", (event) => {
			scrollyEl.scrollBy({
				left: 300,
				behavior: "smooth",
			});
		});

		this.lobbyPrevBtn.addEventListener("click", (event) => {
			// Scroll the scrollyEl to the left 20%;
			scrollyEl.scrollBy({
				left: -300,
				behavior: "smooth",
			});
		});
		const scrollyEl = this.heroScene.querySelector(".os-viewport");
		const resizeMiniFn = () => {
			console.log(scrollyEl.clientWidth);
			if (1400 < scrollyEl.clientWidth) {
				this.lobbyNextBtn.style.display = "none";
				this.lobbyPrevBtn.style.display = "none";
			} else {
				this.lobbyNextBtn.style.display = "block";
				this.lobbyPrevBtn.style.display = "block";
			}
		};
		resizeMiniFn();
		window.addEventListener("resize", resizeMiniFn);
	}

	render() {
		return html`
			<style>
				${css`
					:host {
						--animation-duration: ${unsafeCSS(this.animationDuration)};
						--transient-duration: ${unsafeCSS(this.transientDuration)};
					}
				`}
			</style>

			<slot name="panel-list"></slot>

			<slot name="main-panel" class="display-panel"> no main panel! Add a panel with the name "main-panel" </slot>
			<div class="display-panel loader-panel-wrap">
				<slot name="loader-panel"></slot>
			</div>
			<sl-dialog class="intro-video" style="display: none">
				<div class="video-wrap">
					<video>
						<source src="" type="video/mp4" />
					</video>
				</div>
			</sl-dialog>
		`;
	}
}

// Define custom web component "panel-controller"
window.customElements.define("panel-controller", PanelController);
